import type { Event_Entry } from '@/types/graphql';
import {
    getShowButtonText,
    getShowButtonVariant,
    getShowProgramStart,
    getShowStatus,
} from '@/utils/show';

import { cn } from '@/lib/utils';
import { getShowTicketLink } from '@/utils/show';
import { useTranslations } from 'next-intl';
import type { ButtonVariant } from '../atoms/ButtonLink';
import ButtonLink from '../atoms/ButtonLink';

interface ShowPurchaseButtonProps {
    event: Event_Entry;
}

export default function ShowPurchaseButton({ event }: ShowPurchaseButtonProps) {
    const variant = getShowButtonVariant(event);
    const t = useTranslations('ShowPurchaseButton');

    const programStart = getShowProgramStart(event);
    const status = getShowStatus(event);

    if (new Date(programStart) > new Date()) {
        return (
            <ButtonLink
                href={getShowTicketLink(event)}
                target="_blank"
                variant={variant as ButtonVariant}
                disabled={event.status !== 'active'}
            >
                {t(getShowButtonText(event))}
            </ButtonLink>
        );
    }

    if (new Date(programStart) > new Date() && (status === 'upcoming' || status === 'sold-out')) {
        return (
            <div
                className={cn(
                    'button event-purchase-button text-center',
                    'w-full',
                    'bg-haug-blue-100 text-haug-ivory-100',
                    event.status !== 'active' ? 'disabled' : ''
                )}
            >
                {t(getShowButtonText(event))}
            </div>
        );
    }

    return null;
}
